import { GpsOnly } from '@kinomap-dev/ng-ui-lib/core';

export function convertGpsTrackToGpsOnlyContentTableItem(gpsOnly: GpsOnly): any {
  return {
    id: gpsOnly.id,
    title: { name: gpsOnly.name, thumbnail: gpsOnly.thumbnails },
    sport: gpsOnly.sport,
    level: gpsOnly.difficulty_level,
    sessions: 9999999,
    comments: gpsOnly.comments_count,
    likes: gpsOnly.likes_count,
    labels: ['test', 'my test label', 'is mock'],
  };
}
